// git commit: "fix(adminApi): restore /api/admin base, add smart 401 handler that ignores non-admin routes"
import axios from "axios";

const adminApi = axios.create({
  baseURL: "https://api.larrydigitals.com/api/admin",
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

adminApi.interceptors.response.use(
  (res) => res,
  (err) => {
    // Only redirect to login if the request was actually to an admin endpoint
    // and the token was genuinely rejected — not for other 401s
    if (
      err.response?.status === 401 &&
      err.config?.url &&
      !err.config.url.includes("/social/") &&
      !err.config.url.includes("/wallet") &&
      !err.config.url.includes("/user/")
    ) {
      localStorage.removeItem("adminToken");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export default adminApi;